import React from 'react';
import styles from '../styles/FahrzeugGallery.module.css';
import { useFahrzeuge } from '../contexts/FahrzeugContext';

const FahrzeugGallery = () => {
  const { bilder, loading, error } = useFahrzeuge();

  if (loading) return <p>Lade Bilder...</p>;
  /* if (error) return <p>{error}</p>; */

  console.log(bilder);

  return (
    <>
      {bilder.length > 0 && (
        <div className={styles.section}>
          <div className={styles.container}>
            <h1 className={styles.heading}>What's your Ride?</h1>
            <p className={styles.description}>
              Zwei Räder, vier Räder oder ganz viele PS? <br />Unsere Flotte kann alles. Du musst dich nur entscheiden, womit du durchstartest.
            </p>
            <p className={styles.description}>
              Choose your ride. Let’s go!
            </p>
            {/* <h1 className={styles.heading}>Unterwegs mit Style</h1>
            <p className={styles.description}>
              Ob auf zwei oder vier Rädern – unsere hochmodernen Fahrzeuge bringen dich sicher ans Ziel. Innovativ, zuverlässig und bereit für deine ersten Kilometer. Schnapp dir dein Fahrzeug und leg los!
            </p> */}
            <div className={styles.gallery}>
              {bilder.map((fahrzeug) => {
                const imageUrl = fahrzeug?.img?.filename_disk
                  ? `${process.env.REACT_APP_API_BASE_URL}/assets/${fahrzeug.img.filename_disk}`
                  : null;

                return (
                  imageUrl && (
                    <div className={styles.imageWrapper} key={fahrzeug.id}>
                      <img
                        src={imageUrl}
                        alt={fahrzeug.img.title || `Fahrzeug ${fahrzeug.id}`}
                      />
                      {fahrzeug.Titel && (<h3>{fahrzeug.Titel}</h3>)}
                      {fahrzeug.Beschreibung && (<p className={styles.descr}>{fahrzeug.Beschreibung}</p>)}
                    </div>
                  )
                );
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default FahrzeugGallery;
